// About.js
import React from 'react';
import './About.css';

const About = () => {
  return (
    <div class="container">
      <h1 class="main-heading">About Page</h1>
      <p>Here is some information about this website.</p>
    </div>
  );
};

export default About;
